import { PALETTE, Crescent, OpenBook, SeatedFigure, Shadow, Star } from "./parts";

/**
 * Ders / müzakere halkası: arkada üç figür, önde sırtı dönük iki figür,
 * ortada serili seccadede açık kitaplar.
 */
export default function ReadingCircle({ className = "" }) {
  const { cloud, gold, orange, deep, brand, ink } = PALETTE;
  return (
    <svg viewBox="0 0 420 300" className={className} role="img" aria-hidden="true" focusable="false">
      <ellipse cx={210} cy={160} rx={200} ry={128} fill={cloud} />
      <Crescent x={362} y={104} r={11} color={gold} bg={cloud} />
      <Star x={70} y={62} r={4.5} color={gold} opacity={0.8} />
      <Star x={384} y={150} r={3} color={orange} opacity={0.5} />
      <Star x={112} y={40} r={2.6} color={gold} opacity={0.6} />

      {/* arka sıra */}
      <SeatedFigure x={112} y={196} scale={0.92} robe={brand} robeDark="#3B8F90" arms="rest" />
      <SeatedFigure x={210} y={186} scale={0.92} robe={deep} arms="rest" />
      <SeatedFigure x={308} y={196} scale={0.92} robe="#C9772B" robeDark="#A85F1E" arms="rest" />

      {/* ortadaki seccade ve kitaplar */}
      <Shadow cx={210} cy={238} rx={150} ry={16} opacity={0.1} />
      <ellipse cx={210} cy={226} rx={140} ry={26} fill={gold} opacity={0.35} />
      <ellipse cx={210} cy={226} rx={126} ry={20} fill="none" stroke={orange} strokeWidth={1.3} strokeDasharray="2 5" opacity={0.5} />
      <OpenBook x={172} y={234} w={44} cover={deep} tilt={-6} />
      <OpenBook x={210} y={220} w={42} cover={orange} />
      <OpenBook x={248} y={234} w={44} cover={brand} tilt={6} />

      {/* ön sıra, sırtı dönük */}
      <SeatedFigure x={116} y={296} scale={0.9} robe={ink} robeDark="#0D2E30" back />
      <SeatedFigure x={304} y={296} scale={0.9} robe={deep} back />
    </svg>
  );
}
